<template>
  <div>
    <div>
      <input v-model="password" class="outlined" placeholder="Password">
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'change-user-password-form',
  props: ['payload'],
  data () {
    return {
      password: '',
      is_loading: false
    }
  },
  methods: {
    submit () {
      if (this.password.length < 4) {
        this.$utils.emit('show_toast', { text: 'אנא הקלד/י לפחות 4 תווים' })
        return
      }
      if (!confirm("Are you sure you want to change this user's password?")) {
        return
      }
      this.is_loading = true
      this.$network_utils.updateUser({ user_id: this.payload.user_id, password: this.password }).then(() => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'סיסמה שונתה בהצלחה!' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  }
}
</script>
